import { FilterParams } from 'types/params';

export const chapterQueryKeys = {
    searchChapters: () => ['searchChapters'],
    chapterSchools: () => [...chapterQueryKeys.searchChapters(), 'schools'],
    chapterSchoolsWithFilters: (filters: FilterParams = {}) => [
        ...chapterQueryKeys.chapterSchools(),
        filters,
    ],
};
